export default __webpack_public_path__ + "static/media/icon--your-wallet.4a9e83c9.svg";